import Utils from 'services/utils';
import enLang from './en.lang';

export default class TranslationService {

    constructor() {
        this.init();
    }

    init() {
        this.currentLang = 'en';

        this.lines = {
            en: enLang
        };
    }

    getLine(key, vars = {}) {
        const line = this.lines[this.currentLang][key] || '';
        return Utils.formatString(vars, line);
    }

    getCurrentLanguage() {
        return this.currentLang;
    }
}



// WEBPACK FOOTER //
// ./app/services/translation/translation.service.js